import React, { useState } from "react";
import withProviders from "../hooks/withProviders";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import { useFilterContext } from "../hooks/FilterContext";
import { ReviewManagementFiltersModal, ReviewManagementFiltersModalButton } from "../features/reviewmanagementfilters";
import { ClientReviewManagementPageSubHeader, Main, ThemedIcon, ThemedParagraph } from "../components/utilities";
import PageHeader, { PageHeaderTop, PageHeaderBottom } from "../components/layout/PageHeader";
import { ManagementReviewRouteTabs } from "../routes/management.reviews.routes";
import { EditReviewProvider } from "../features/reviewmanagementeditmodal/hooks/EditReviewContext";
import { FilterProvider, ReviewManagementDefaultFilters } from "../hooks/FilterContext";
import { FormSelect } from "../components/forms";
import { openCompletedReviewFiltersModal } from "./../components/modals/completed-review-filter";
import { IconButton } from "../components";

const ReviewManagementHeaderTitle = styled.div`
    flex: 1;
    display: flex;
    font-size: 16px;

    & > span:not(:last-child) {
        margin-right: 1rem;
    }
`;

const ReviewManagementFiltersAppliedWarningMessage = styled(ThemedParagraph)`
    font-size: 12px !important;
`;

const StyledFormSelect = styled(FormSelect)`
    width: 250px;
`;

export const ClientReviewManagementFilterSubHeader = ({includeCompletedSelect}) => {
    const { clearFilter, filter : {targetRatesMinimumStandard}, defaultFilters, isFiltersApplied, setFilter, setShowFilterModal } = useFilterContext();

    return (
         <ClientReviewManagementPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <ReviewManagementFiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </ReviewManagementFiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex flex-fill justify-content-end align-items-center gap-2">

                        {includeCompletedSelect != false &&
                            <StyledFormSelect
                                options={[
                                    {label: "Optimum", value: 0},
                                    {label: "Acceptable", value: 1},
                                    {label: "Missed Standard", value: 2},
                                ]}
                                defaultValue={targetRatesMinimumStandard}
                                disableAnimations={true}
                                onChange={(value) => setFilter(original => {
                                    return {
                                        ...original,
                                        targetRatesMinimumStandard: value.value
                                    }
                                })}
                            />
                            }
                        <ReviewManagementFiltersModalButton onClick={() => setShowFilterModal(true)} />
                    </div>
                </div>
            </ClientReviewManagementPageSubHeader>
    )
}

export const CompletedReviewsFilterSubHeader = () => {
    const { filter, clearFilter, isFiltersApplied, setFilter } = useFilterContext();
    
    const onFilterButtonClicked = () => {
        openCompletedReviewFiltersModal(filter).then(
            form => {
                const { searchTerm, ...rest } = form;
                setFilter(() => ({ ...rest }));
            }
        );
    };

    return (
         <ClientReviewManagementPageSubHeader>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center">
                        {isFiltersApplied && (
                            <React.Fragment>
                                <ThemedIcon icon="fa-triangle-exclamation" size="2x" variant="warning" />
                                <ReviewManagementFiltersAppliedWarningMessage className="ms-2 text-muted">
                                    Warning - Filters are currently being applied to your results.
                                    <br />
                                    <a href="#" onClick={clearFilter}>Click here</a> to clear your filters.
                                </ReviewManagementFiltersAppliedWarningMessage>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="d-flex justify-content-end gap-2 align-items-center">
                        <div className="d-flex gap-1">
                            <IconButton icon="fas fa-filter" onClick={onFilterButtonClicked}>Filter Completed Reviews</IconButton>
                        </div>
                    </div>
                </div>
            </ClientReviewManagementPageSubHeader>
    )
}

const ClientReviewManagementLayout = () => {

    const { showFilterModal, setShowFilterModal } = useFilterContext();

    return <React.Fragment>
        <ReviewManagementFiltersModal 
            handleClose={() => setShowFilterModal(false)}
            show={showFilterModal}
        />
        <PageHeader>
            <PageHeaderTop>
                <ReviewManagementHeaderTitle>
                    <span>Service Reviews Management</span>
                </ReviewManagementHeaderTitle>
            </PageHeaderTop>
            <PageHeaderBottom>
                <ManagementReviewRouteTabs />
            </PageHeaderBottom>
        </PageHeader>
        <Main className="d-flex flex-column">
            <EditReviewProvider>
                <Outlet />
            </EditReviewProvider>
        </Main>
    </React.Fragment>
}

export default withProviders([FilterProvider, { filterStore: "reviews", defaultFilters: ReviewManagementDefaultFilters }])(ClientReviewManagementLayout);